import React from 'react';
import classes from './Slogans.css';

const slogans = (props) => (
    <p className={classes.Slogans}>"The personal touch at your local family barber!"</p>
);

export default slogans;


// WEBPACK FOOTER //
// ./src/components/Slogans/Slogans.js